/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

const theme = {
  palette: {
    type: 'light', // @Feature: Dark mode "dark"
    background: {
      default: '#fff',
    },
    primary: {
      contrastText: '#fff',
      dark: '#000d6a',
      light: '#685dcb',
      main: '#333399',
    },
    secondary: {
      contrastText: '#fff',
      dark: '#650000',
      light: '#d1432b',
      main: '#990000',
    },
    error: {
      main: '#990000',
    },
    text: {
      disabled: 'rgba(0, 0, 0, 0.54)',
      hint: 'rgba(0, 0, 0, 0.38)',
      primary: 'rgba(0, 0, 0, 0.95)',
      secondary: 'rgba(0, 0, 0, 0.54)',
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottomColor: '#333399',
        },
      },
    },
    MuiCircularProgress: {
      colorPrimary: '#333399',
      colorSecondary: '#000d6a',
    },
    MuiLinearProgress: {
      colorPrimary: '#333399',
      colorSecondary: '#0059c1',
    },
  },
  typography: {
    useNextVariants: true,
  },
};

export { theme as default };
